import { render, staticRenderFns } from "./EditReason.vue?vue&type=template&id=3ef7dcaf&scoped=true"
import script from "./EditReason.vue?vue&type=script&lang=js"
export * from "./EditReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef7dcaf",
  null
  
)

export default component.exports